import './styles.scss';

import React from 'react';

const VideoComponent = ({ videoId }) => (
    <div className="video-container">
        <iframe
            src={`//players.brightcove.net/6415718365001/default_default/index.html?videoId=${videoId}`}
            allowFullScreen
            allow="encrypted-media"/>
    </div>
);

export default VideoComponent;
